import { useParams } from 'react-router-dom';
import { SendOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { refetchSnapDetailsAction } from 'containers/Snaps/Snap/store';

import { usePostRequest } from 'hooks';

import { Transaction } from 'codegen';

export const SendTransaction = ({
  status,
  statusCode,
  transactionId,
  refetchTransactions,
}: {
  status?: Transaction.status,
  statusCode?: number;
  transactionId?: number;
  refetchTransactions: () => void;
}) => {
  const { snapId } = useParams();

  const [sendTransaction, { loading }] = usePostRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}/issuance`,
    options: {
      onSuccess: () => {
        refetchTransactions();
        refetchSnapDetailsAction();
      },
    },
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;
  const showSendBtn = !statusCode || statusCode === 500;

  if (!showSendBtn || isBackedOut) {
    return null;
  }

  return (
    <Button
      type='text'
      icon={<SendOutlined title='Send' className='text-[#52c41a]' />}
      loading={loading}
      onClick={() => sendTransaction()}
    />
  );
};
